import React from 'react';
import { ScrollViewProps, StyleSheet } from 'react-native';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import Animated, {
  scrollTo,
  useAnimatedRef,
  useSharedValue,
} from 'react-native-reanimated';
import { AnimatedScrollView } from 'react-native-reanimated/lib/typescript/component/ScrollView';

const HorizontalScrollView = (props: ScrollViewProps) => {
  const offsetX = useSharedValue(0);
  const isCloseToRight = useSharedValue(false);
  const isCloseToLeft = useSharedValue(true);
  const scrollRef = useAnimatedRef<AnimatedScrollView>();

  const gesture = Gesture.Pan().onChange((event) => {
    if (
      (event.translationX > 0 && isCloseToLeft.value) ||
      (event.translationX < 0 && isCloseToRight.value)
    ) {
      return;
    }
    const newOffsetX = offsetX.value - event.translationX * 0.05;
    scrollTo(scrollRef, newOffsetX, 0, false);
  });

  return (
    <GestureDetector gesture={gesture}>
      <Animated.ScrollView
        ref={scrollRef}
        horizontal={true}
        showsHorizontalScrollIndicator={false}
        scrollEventThrottle={16}
        style={styles.scrollView}
        contentContainerStyle={[styles.contentContainer]}
        onScroll={(event) => {
          props.onScroll?.(event);
          const offsetXValue = event.nativeEvent.contentOffset.x;
          isCloseToLeft.value = offsetXValue <= 0;
          isCloseToRight.value =
            offsetXValue + event.nativeEvent.layoutMeasurement.width >=
            event.nativeEvent.contentSize.width;
          offsetX.value = offsetXValue;
        }}
        {...props}
      >
        {props.children}
      </Animated.ScrollView>
    </GestureDetector>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingVertical: 10,
  },
  scrollView: {
    flex: 1,
  },
});

export default HorizontalScrollView;
